import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/courses/:courseId/activities/:activityId/survey/:id/:attemptId?',
        component: () => import('@/pages/courses/quizzes/Quiz.vue'),
        props: true,
        children: [
            {
                name: 'survey-attempt',
                path: '',
                component: () => import('@/components/quiz-attempt/QuizAttempt.vue'),
                meta: {
                    title: 'Survey',
                    middleware: [GateKeeperMiddleware],
                    ability: async ({ gateKeeper, to }) =>
                        (await gateKeeper.userHasAccessToCourse(to.params.courseId)) &&
                        (gateKeeper.userHasPermission('create a quiz attempt') ||
                            gateKeeper.userHasAccessToPreviewQuiz(to.params.courseId)),
                },
            },
        ],
    },
];
